import { useCallback } from 'react';
import { UseMutationResult } from '@tanstack/react-query';
import { ToggleLikeResponse } from '@sdk/newsfeed/types/apiTypes';

import { Article } from '@web/newsfeed/types/Article';
import { AddPostLikePayload } from '@web/newsfeed/types/apiTypes';

type ArticleProps = {
  pageId: number;
  articleId: number;
};

export function useToggleLike(
  addLikeMutation: UseMutationResult<ToggleLikeResponse, unknown, AddPostLikePayload, void>,
  removeLikeMutation: UseMutationResult<ToggleLikeResponse, unknown, AddPostLikePayload, void>
) {
  return useCallback(
    (article: Article) => {
      const addLike = async (payload: ArticleProps) => {
        await addLikeMutation.mutateAsync(payload);
      };

      const removeLike = async (payload: ArticleProps) => {
        await removeLikeMutation.mutateAsync(payload);
      };

      if (article.likedByMe) {
        removeLike({ pageId: article.page.id, articleId: article.id });
      } else {
        addLike({ pageId: article.page.id, articleId: article.id });
      }
    },
    [addLikeMutation, removeLikeMutation]
  );
}
